import * as React from 'react';
// import { metaMaskInstalled } from "../../Authentication/eth";
import classNames from 'classnames';

import './ConnectButton.sass';
import {eth} from '../../Authentication/eth';


export const ConnectButton: React.FC<{
    loading: boolean;
    onPress: () => any;
}> = (props) => {
    function handleClick() {
        if (!props.loading) {
            if (eth) {
                props.onPress();
            }
            else {
                window.open('https://www.metamask.io/');
            }
        }
    }


    return (
        <div className={'mvc-connect-button'}>
            <span>{!props.loading ? 'Connect' : 'Connecting...'}</span>
            <div
                className={classNames('mvc-connect-button-image', {
                    loading: props.loading,
                    faded: !eth,
                })}
                onClick={handleClick}
            />
            {TermsOfUseAndPrivacyPolicy}
        </div>
    );
};

const TermsOfUseAndPrivacyPolicy = (
    <span className={'mvc-connect-button-description'}>
    By connecting to Metaverse Chat, you agree to the{' '}
        <span
            className={'mvc-connect-button-description-link'}
            onClick={() => window.open('https://nftworld.io/terms-of-use/')}
        >
      Terms of Use
    </span>{' '}
        and{' '}
        <span
            className={'mvc-connect-button-description-link'}
            onClick={() => window.open('https://nftworld.io/privacy-policy/')}
        >
      Privacy Policy
    </span>
  </span>
);
